import { axiosInstance } from '../axiosConfig';
import { handleRequestWithAuth } from '../refreshService';

const API_URL = 'saved-filters/';

export interface SavedFilter {
    id: number;
    user: number;
    model_name: string;
    filter_name: string;
    parameters: Record<string, any>;
    is_default: boolean;
    auto_apply: boolean;   // <- NUEVO campo
    created_at: string;
    updated_at: string;
}

export interface FilterParams {
    [key: string]: any;
}

export interface AvailableDefaultsResponse {
    personal_filters: SavedFilter[];
    current_default_id: number | null;
    current_default_name: string | null;
}

export const filterService = {
    // Obtener filtros por modelo
    getFiltersByModel: async (modelName: string): Promise<SavedFilter[]> => {
        return handleRequestWithAuth(async () => {
            const response = await axiosInstance.get(`${API_URL}by_model/`, {
                params: { model_name: modelName }
            });
            return response.data;
        });
    },

    // Obtener filtro predeterminado (incluye auto_apply)
    getDefaultFilter: async (modelName: string): Promise<SavedFilter | null> => {
        return handleRequestWithAuth(async () => {
            const response = await axiosInstance.get(`${API_URL}default/`, {
                params: { model_name: modelName }
            });
            return response.data || null;
        });
    },

    // Obtener filtros disponibles para predeterminado
    getAvailableDefaults: async (modelName: string): Promise<AvailableDefaultsResponse> => {
        return handleRequestWithAuth(async () => {
            const response = await axiosInstance.get(`${API_URL}available_defaults/`, {
                params: { model_name: modelName }
            });
            return response.data;
        });
    },

    // Crear nuevo filtro (soporta auto_apply)
    createFilter: async (data: {
        model_name: string;
        filter_name: string;
        parameters: FilterParams;
        is_default?: boolean;
        auto_apply?: boolean;
    }): Promise<SavedFilter> => {
        return handleRequestWithAuth(async () => {
            const response = await axiosInstance.post(API_URL, data);
            return response.data;
        });
    },

    // Actualizar filtro
    updateFilter: async (id: number, data: Partial<SavedFilter>): Promise<SavedFilter> => {
        return handleRequestWithAuth(async () => {
            const response = await axiosInstance.put(`${API_URL}${id}/`, data);
            return response.data;
        });
    },

    // Eliminar filtro
    deleteFilter: async (id: number): Promise<void> => {
        return handleRequestWithAuth(async () => {
            await axiosInstance.delete(`${API_URL}${id}/`);
        });
    },

    // Establecer como predeterminado (backend pone auto_apply = true)
    setAsDefault: async (id: number): Promise<SavedFilter> => {
        return handleRequestWithAuth(async () => {
            const response = await axiosInstance.post(`${API_URL}${id}/set_as_default/`);
            return response.data;
        });
    },

    // Desactivar auto-aplicación del filtro predeterminado
    dismissDefaultFilter: async (modelName: string): Promise<void> => {
        return handleRequestWithAuth(async () => {
            await axiosInstance.post(`${API_URL}dismiss-default/`, { model_name: modelName });
        });
    }
};